import { render, staticRenderFns } from "./InSidebar.vue?vue&type=template&id=470f04eb&scoped=true&"
import script from "./InSidebar.vue?vue&type=script&lang=js&"
export * from "./InSidebar.vue?vue&type=script&lang=js&"
import style0 from "./InSidebar.vue?vue&type=style&index=0&id=470f04eb&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "470f04eb",
  null
  
)

export default component.exports